import constant from "../../constant";
import axios from "axios";
import router from "../../router";
const api = constant.api + "sellers_customers";
// initial state
const state = () => ({
  all: [],
  sellerCustomers: [],
  sellerCustomer: {},
});

// getters
const getters = {
  getAll: (state) => {
    return state.all;
  },
  getSellerCustomer: (state) => {
    return state.sellerCustomer;
  },

  getSellerCustomers: (state) => {
    return state.sellerCustomers;
  },
};

// actions
const actions = {
  async getAll({ commit }) {
    await axios.get(api).then((response) => {
      let sellerCustomers = response.data;
      commit("setSellerCustomers", sellerCustomers);
    });
  },
  async show({ commit }, reference) {
    await axios.get(api + "/" + reference).then((response) => {
      let sellerCustomer = response.data;
      commit("setSellerCustomer", sellerCustomer);
    });
  },

  async destroy({ commit, dispatch }, reference) {
    await this.$api.delete(api + "/" + reference).then((response) => {
      let message = response.data.message;
      let status = response.data.status;
      dispatch("notification/store", { status, message }, { root: true });
      if (status == "success") {
        let sellerCustomers = response.data.data;
        commit("setSellerCustomers", sellerCustomers);
      }
    });
  },

  async store({ commit, dispatch }, data) {
    await this.$api.create(api, data).then((response) => {
      let message = response.data.message;
      let status = response.data.status;
      dispatch("notification/store", { status, message }, { root: true });
      if (status == "success") {
        router.push({
          name: "seller-customers-index",
        });
      }
    });
  },

  async update({ dispatch }, data) {
    await this.$api
      .update(api + "/" + data.reference, data)
      .then((response) => {
        let message = response.data.message;
        let status = response.data.status;

        if (status == "success") {
          dispatch("notification/store", { status, message }, { root: true });
          router.push({
            name: "seller-customers-index",
          });
        }
      });
  },
};

// mutations
const mutations = {
  setSellerCustomers(state, sellerCustomers) {
    state.all = sellerCustomers;
    state.sellerCustomers = sellerCustomers;
  },
  setSellerCustomer(state, sellerCustomer) {
    state.sellerCustomer = sellerCustomer;
  },
  async search(state, value) {
    value = value.charAt(0).toUpperCase() + value.slice(1);
    console.log(value);
    state.sellerCustomers = state.all.filter(function (sellerCustomer) {
      return (
        (sellerCustomer.firstName &&
          sellerCustomer.firstName.toUpperCase().indexOf(value.toUpperCase()) >
            -1) ||
        (sellerCustomer.lastName &&
          sellerCustomer.lastName.toUpperCase().indexOf(value.toUpperCase()) >
            -1) ||
        (sellerCustomer.fullName &&
          sellerCustomer.fullName.toUpperCase().indexOf(value.toUpperCase()) >
            -1) ||
        (sellerCustomer.phone &&
          sellerCustomer.phone.toUpperCase().indexOf(value.toUpperCase()) >
            -1) ||
        (sellerCustomer.email &&
          sellerCustomer.email.toUpperCase().indexOf(value.toUpperCase()) >
            -1) ||
        (sellerCustomer.reference &&
          sellerCustomer.reference.toUpperCase().indexOf(value.toUpperCase()) >
            -1)
      );
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
